import { lazy, Suspense, useEffect } from "react";
import CryptoJS from "crypto-js";
import SuspenceComponent from "components/SuspenceComponent";
import MDButton from "components/MDButton";
import { USER_DATA_STORAGE } from "constant";
// import { apiUrlTraccar } from "constant/apiUrl.ts";

const ModuleTitle = lazy(() => import("components/ModuleTitle"));

export default function GeolocationHomePage() {
  const { REACT_APP_API_URL_TRACCAR } = process.env;
  const SECRET_KEY = "7C4E5BFB236BE229F3A19D9718928";
  const handleRedirect = () => {
    /* const email = "bambicamara1@gmail.com"; 
        const password = "bambi"; */
    // const params = "email=oumousow&password=sow";
    const connectedUser = localStorage.getItem(USER_DATA_STORAGE)
      ? JSON.parse(localStorage.getItem(USER_DATA_STORAGE))
      : null;

    // console.log("connectedUser ", connectedUser?.matricul);
    const params = {
      email: `${connectedUser?.matricul}@betaclic.com`,
      password: connectedUser?.matricul,
    };
    // const params = { email: "bambicamara1@gmail.com", password: "bambi" };
    // const params = { email: "admin.ne@betaclic.com", password: "AdminNer1110@0" };
    const stringParams = JSON.stringify(params);

    const cipherParams = CryptoJS.AES.encrypt(stringParams, SECRET_KEY).toString();
    const safeCipher = encodeURIComponent(cipherParams);
    // const url = `http://localhost:3000/login?params=${safeCipher}`;
    // const url = `http://217.182.69.179:8082/login?params=${safeCipher}`;
    const url = `${REACT_APP_API_URL_TRACCAR}/login?params=${safeCipher}`;
    // const url = `https://tracking.betaclic.com/login?params=${safeCipher}`;
    // const url1 = `http://217.182.69.179:8082/login?${params}`;
    // const url = "http://217.182.69.179:8082/login?" + cipherParams;
    // eslint-disable-next-line no-undef
    window.open(url, "_blank");
    // console.log("eee", url);
    // console.log("cipherParams", cipherParams);
  };

  useEffect(() => {
    handleRedirect();

    /* const connectedUser = localStorage.getItem(USER_DATA_STORAGE);
  console.log("connectedUser ", connectedUser.matricul); */
  }, []);

  return (
    <Suspense fallback={<SuspenceComponent />}>
      <ModuleTitle title="Géolocalisation des animaux" />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 10,
          // backgroundColor: "green",
        }}
      >
        <MDButton type="submit" variant="gradient" color="info" onClick={handleRedirect}>
          Accéder à la géolocalisation
        </MDButton>
      </div>
    </Suspense>
  );
}
